<template>
  <div />
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
